// extracted by css-extract-rspack-plugin
export default {"button":"_9da36566"};